import React, {useContext, useEffect, useState} from 'react';
import axios from 'axios';
import axiosAll from 'axios';
import Icon from '@material-ui/core/Icon';
import {Link, withRouter} from "react-router-dom";
import classes from './MenuIdeaDetailPage.module.scss';
import Loadable from "react-loadable";
import Loading from "./HeroImage/HeroImage";
import {isMobileOnly} from "react-device-detect";
import MenuIdeasTitle from "../../../components/UI/MenuIdeaTitle/MenuIdeasTitle";
import {HomeBreadcrumb} from "../../../components/UI/HomeButton";
import {gaTracker} from "../../../helper/Helper";
import ReactGa from "react-ga";
import scrollToComponent from "react-scroll-to-component";
import JIcon from "../../../components/UI/Icon/JIcon";
import {Helmet} from "react-helmet";
import CardMenuIdeas from "../../../components/UI/Cards/CardMenuIdeas/CardMenuIdeas";
import Product from "../../ProductCategoryPage/Products/Product/Product";
import {Facebook, Twitter, Whatsapp} from 'react-social-sharing';
import {LoadingSimple} from "../../../components/UI/LoadingBar";
import {FormattedMessage} from "react-intl";
import {Context} from "../../../context/Wrapper";

// const HeroImage = React.lazy(() => import('./HeroImage/HeroImage'))
const LoadableComponent = Loadable({loader: () => import('./HeroImage/HeroImage'), loading: Loading,});
// const LoadableTransition = Loadable({loader: () => import('./HeroImage/HeroTransition'), loading: Loading,});

//add by hendra on 13 oct 2020 06.00 pm
const [paramCategory] = ['ShareButton'];
const [paramCategoryLoad, paramActionLoad] = ['MenuIdeaLoad', 'View Menu Ideas Detail'];

// const initialState = {}
// const reducer = (state, action) => {
//     switch (action.type) {
//         case IS_LOADING:
//             return {
//                 ...state,
//             }
//         default:
//             return state;
//     }
// }


const MenuIdeaDetailPageHook = (props) => {
    //const [sstate, dispatch] = useReducer(reducer, initialState);
    const context = useContext(Context)

    const [state, setState] = useState({
        isLoading: false
        , menu_idea: []
        , ingredients: []
        , products_used: []
        , menu_ideas_also_like: []

        , product_category_page: []
        , menu_ideas: []
        , all_menu_ideas: []
        , related_menu_ideas: []
        , home_product_categories: []
        , product_brands: []
        , product_sub_categories: []
        , products: []
        , product_images: []
        , product_certification: []
        , product: null
        , main_image: null
        , product_fields_description: []
        , all_ingredients: []
        , related_products: []
    });

    useEffect(() => {
        //=================================================
        // console.log('useEffect 1');
        //=================================================

        //add by hendra on 14 oct 2020
        ReactGa.pageview(window.location.origin.toString() + props.location.pathname);
        const loadDocumentTitle = () => {
            document.title = localStorage.getItem('menu_ideas:selected_detail') !== null ?
                localStorage.getItem('menu_ideas:selected_detail') &&
                localStorage.getItem('menu_ideas:selected_detail').concat(" | Japfa Food | Indonesia | Food Supplier")
                :
                "Menu Ideas Detail | Japfa Food | Indonesia | Food Supplier"
        }
        window.scrollTo(0, 0);

        const ourRequest = axios.CancelToken.source();
        const fetchData = async () => {
            setState({...state, isLoading: true})
            const header = {headers: {'language': context.locale}};
            const getData_1 = await axios.get('menu_idea/' + props.match.params.id, header);
            const selectedMenu = getData_1.data;

            const getData_2 = await axios.get('ingredients/' + selectedMenu.menu_idea_cd, header);
            const products_used = await axios.get('product_used/' + selectedMenu.menu_idea_cd, header);
            const menu_ideas_also_like = await axiosAll.get('menu_ideas_also_like/' + selectedMenu.product_category_cd + '/' + selectedMenu.menu_idea_cd, header);
            gaTracker(paramCategoryLoad, paramActionLoad, selectedMenu.title);
            setState({
                isLoading: false
                , menu_idea: selectedMenu
                , ingredients: getData_2.data.ingredients
                , products_used: products_used.data.products
                , menu_ideas_also_like: menu_ideas_also_like.data.menu_ideas_also_like
            });
        }
        fetchData().catch(e => {
            if (e.response.status === 404) {
                props.history.replace("/page-not-found")
            }
        });
        loadDocumentTitle();

        //hooks cleanup
        return () => {
            ourRequest.cancel() // <-- 3rd step
        }

        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.location.pathname, props.history, props.match.params.id, context.locale, context.locale]);

    const gotoProductDetail = (slug, paramProduct) => {
        localStorage.setItem('selected_product_name', paramProduct.name)
        if (isMobileOnly) {
            props.history.push('/product-detail/' + slug);
        } else {
            window.open('/product-detail/' + slug)
        }
    }

    const onShareButton = (paramAction, paramLabel) => {
        gaTracker(paramCategory, paramAction, paramLabel)
    }

    let relatedMenuIdeas = <p>No data Render</p>
    if (state.menu_ideas_also_like) {
        relatedMenuIdeas = state.menu_ideas_also_like.map((data, index) => {
            return (<CardMenuIdeas key={`${data.menu_idea_cd}${index}`} data={data}/>);
        });
    }

    let localIngredients = <p>Sorry, data not found</p>;
    if (state.ingredients) {
        localIngredients = state.ingredients.map((item, index) => {
            const ingredientsInfo = item.qty ? item.qty + ' ' + item.name : item.name;
            return (
                <li key={index}>
                    {(item.product_cd !== null ? <span onClick={() => gotoProductDetail(item.product_slug, item)}>{ingredientsInfo}</span>
                        : ingredientsInfo)}
                </li>
            );
        })
    }

    let localRelatedProducts = (<LoadingSimple/>);
    if (state.products_used.length > 0) {
        localRelatedProducts = state.products_used.map((item, index) => {
            return (
                <li key={`${item.product_category_cd}${index}`}
                    className={classes.ProductsCard_row}>
                    <Product prod={item}/>
                </li>
            );
        });
    }

    let tempMetaDesc = '';
    let metaDesc = '';
    if (state.menu_idea.id !== undefined) {
        tempMetaDesc = state.menu_idea.content.replace(/(<([^>]+)>)/ig, "");
        metaDesc = tempMetaDesc.length > 150 ? tempMetaDesc.substr(0, 150).trim() : tempMetaDesc.trim();
    }

    let heroImage = '';
    if (state.menu_idea.hero_image !== undefined) {
        heroImage = <LoadableComponent hero_image={state.menu_idea.hero_image}/>;
    }

    return (
        <>
            <div className={["violet", classes.MenuIdeas_container, "application"].join(' ')} ref={(section) => {
                scrollToComponent.Violet = section;
            }}>

                <Helmet>
                    <meta name="description" content={metaDesc}/>
                    <meta name="keywords" content={"menu ideas, food service, frozen food, supplier frozen food, Best Chicken, Tokusen, Omayo, food catering, food service delivery, Japfa Indonesia, meat shop, Chicken shop, food solutions, JBFS, Food Supplier"}/>
                    <meta name="author" content=""/>
                    <meta property="og:title" content={
                        state.menu_idea.title &&
                        state.menu_idea.title.concat(" | Japfa Food | Indonesia | Food Supplier")}/>
                    <meta property="og:description" content={"JAPFA FOOD: " + metaDesc}/>
                    <meta property="og:image" content={state.menu_idea.hero_image}/>
                    <title>{
                        localStorage.getItem('menu_ideas:selected_detail')
                        && `${localStorage.getItem('menu_ideas:selected_detail')}${(" | Japfa Food | Indonesia | Food Supplier")}`
                    }</title>

                    <link rel="canonical" href={window.location.origin.toString() + props.location.pathname}/>
                </Helmet>

                {/*Bread crumbs region*/}
                <section className={[classes.Breadcrumb_section].join(' ')}>
                    <div className={["jbfs-wrapper"].join(' ')}>
                        {/*Breadcrum region*/}
                        <div className={["jbfs-breadcrumb-row",].join(' ')}>
                            <HomeBreadcrumb/><span>/</span>
                            <Link to={'/menu-ideas/'}><FormattedMessage id={"menuideas.title"} defaultMessage={"Menu Ideas"}/></Link><span>/</span>
                            <div>{!state.isLoading && state.menu_idea !== undefined ? state.menu_idea.title : <LoadingSimple size={"small"}/>}</div>
                        </div>
                        {/*Breadcrum region*/}
                    </div>
                </section>
                {/*----------*/}
                <section className={[classes.Content_section].join(' ')}>
                    <div className={["jbfs-wrapper", classes.Content_wrapper].join(' ')}>

                        <div className={classes.Header_title}>
                            <h1>{state.isLoading ? <LoadingSimple position={"left"}/> : state.menu_idea.title}</h1>
                        </div>

                        <div className={classes.Card_header}>
                            {/*{state.isLoading ? <LoadableTransition/> : heroImage}*/}
                            {state.menu_idea.hero_image && heroImage}
                            <div className={classes.Card_header_description}>

                                <div className={classes.Grid_item}>
                                    <h4><FormattedMessage id={"menuideasdetail.cooktime"} defaultMessage={"Cook Time"}/></h4>
                                    <div className={classes.Card_header_description_cook_time}>
                                        <Icon className={classes.Cooktime_icon} style={{fontSize: 20}}>access_time</Icon>
                                        <div className={classes.Card_header_description_label}>
                                            <p>{(state.menu_idea.cook_time !== undefined ? state.menu_idea.cook_time : '...')}<span>&nbsp;<FormattedMessage id={"menuideasdetail.minutes"} defaultMessage={"minutes"}/></span></p>
                                        </div>
                                    </div>
                                </div>
                                <div className={classes.Grid_item}>
                                    <h4><FormattedMessage id={"menuideasdetail.serving"} defaultMessage={"Serving"}/></h4>
                                    <div className={classes.Card_header_description_label}>
                                        <p>{(state.menu_idea.serving !== undefined ? state.menu_idea.serving : '...')}<span>&nbsp;<FormattedMessage id={"menuideasdetail.people"} defaultMessage={"people"}/></span></p>
                                    </div>
                                </div>
                                <div className={classes.Grid_item}>
                                    <h4><FormattedMessage id={"menuideasdetail.difficulty"} defaultMessage={"Difficulty"}/></h4>
                                    <div className={classes.Card_header_description_label}>
                                        <p>{state.menu_idea.difficulty !== undefined ? state.menu_idea.difficulty : '...'}</p>
                                    </div>
                                </div>
                                <div className={classes.Grid_item}>
                                    <h4><FormattedMessage id={"menuideasdetail.type"} defaultMessage={"Type of Dish"}/></h4>
                                    <div className={classes.Card_header_description_label}>
                                        <p className={"jbfs-title-case"}>{state.menu_idea.type_of_dish !== undefined ? state.menu_idea.type_of_dish : '...'}</p>
                                    </div>
                                </div>
                                <div className={classes.HeaderContent_sosmed}>
                                    <hr className={classes.Grid_separator}/>
                                    <h4><FormattedMessage id={"menuideasdetail.share"} defaultMessage={"Share this menu ideas"}/>:</h4>
                                    <Facebook link={window.location.origin.toString() + props.location.pathname} onClick={() => onShareButton('Facebook', state.menu_idea.title)}/>
                                    <Twitter link={window.location.origin.toString() + props.location.pathname} onClick={() => onShareButton('Twitter', state.menu_idea.title)}/>
                                    <Whatsapp link={window.location.origin.toString() + props.location.pathname} onClick={() => onShareButton('Whatsapp', state.menu_idea.title)}/>
                                    {/*<IconSocialMedia/>*/}
                                </div>

                            </div>
                        </div>

                    </div>
                </section>

                <section className={[classes.Recipe_section].join(' ')}>
                    <div className={["jbfs-wrapper", classes.Recipe_wrapper].join(' ')}>
                        <h3>{state.menu_idea.title}</h3>
                        <div dangerouslySetInnerHTML={{__html: state.menu_idea.content}}/>
                        <hr/>
                    </div>
                </section>

                <section className={[classes.Ingredient_section].join(' ')}>
                    <div className={["jbfs-wrapper", classes.Ingredient_row].join(' ')}>
                        <div className={classes.Ingredient_wrapper}>
                            <div>
                                <h4><FormattedMessage id={"menuideasdetail.content.ingredients"} defaultMessage={"Ingredients"}/></h4>
                                <ul>
                                    {localIngredients}
                                </ul>
                            </div>
                            <hr className={classes.Ingredient_separator}/>
                            <div>
                                <h4><FormattedMessage id={"menuideasdetail.content.directions"} defaultMessage={"Directions"}/></h4>
                                <p dangerouslySetInnerHTML={{__html: (state.menu_idea.directions ? state.menu_idea.directions : 'Sorry, no data available')}}/>
                            </div>
                        </div>
                        <hr/>
                    </div>
                </section>


                <section className={[classes.ProductUsed_section].join(' ')}>
                    <div className={["jbfs-wrapper", classes.ProductUsed_wrapper].join(' ')}>
                        <h3><FormattedMessage id={"menuideasdetail.content.used"} defaultMessage={"Product used for this menu ideas"}/></h3>
                        <div className={classes.ProductUsed_wrapperCard}>
                            <ul className={classes.ProductsCard_wrapper}>
                                {localRelatedProducts !== null ? localRelatedProducts : <p>This menu doesn't have related products used</p>}
                            </ul>
                        </div>
                    </div>
                </section>

                <section className={[classes.RelatedMenuIdeas_section].join(' ')}>
                    <div className={["jbfs-wrapper", classes.RelatedMenuIdeas_wrapper].join(' ')}>
                        <MenuIdeasTitle title={<FormattedMessage id={"menuideasdetail.content.youmayalso"} defaultMessage={"You may also like"}/>} fontSize={40}/>
                        <div className={classes.RelatedMenuIdeas_container}>
                            {relatedMenuIdeas}
                        </div>
                    </div>
                </section>
                <div className={["jbfs-arrow-top",].join(' ')}>
                    <JIcon icontype={"link_to_top"}
                           onClick={() => scrollToComponent(scrollToComponent.Violet, {offset: -99, align: 'top', duration: 1500})}/>
                </div>
            </div>
        </>
    )
}

export default withRouter(MenuIdeaDetailPageHook)